<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login.png"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container-otd">
                <div class="row justify-content-md-center">
                  <div>
                    <vs-col
                      class="kijinput"
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="12"
                    >
                      <vs-select
                              class="w-full"
                              autocomplete
                              label="Votre âge"
                              v-model="input.birthday"
                              placeholder="Sélectionner l'âge"
                      >
                          <vs-select-item
                                  :key="index"
                                  :value="item"
                                  :text="item"
                                  v-for="(item,index) in period"
                          />
                      </vs-select>
                    </vs-col>

                    <vs-col
                      class="mt-2"
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                      vs-w="12"
                    >
                      <vs-select
                              class="w-full"
                              autocomplete
                              label="Votre ancienneté"
                              v-model="input.hired_at"
                              placeholder="Sélectionner l'ancienneté"
                      >
                          <vs-select-item
                                  :key="index"
                                  :value="item"
                                  :text="item"
                                  v-for="(item,index) in period"
                          />
                      </vs-select>
                    </vs-col>
                  </div>

                  <div class="">
                    <vs-button class="mt-12 mb-5" @click="submitData"
                      >Valider</vs-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
var base_self;
var input_tempon = {
  deleted_at: "",
  id: "",
  slug: "",
  firstname: "", //
  lastname: "", //
  email: "", //
  phone: "",
  birthday: "",
  hired_at: "",
  others: "",
  fonction_id: "",
  media_id: "",
  email_notification: "",
  firstly: "",
  team_id: "",
  manager: false,
  channel: true,
  state: "",
  email_verified_at: "",
  reset_password_token_hired_at: "",
  created_at: "", //
  updated_at: "",
  role: {}, //
  fonction: {}, //------------
  media: {},
  team: {}, //------------
};
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";

export default {
  props: {
    base: "",
  },
  components: {
    VuePerfectScrollbar,
    Datepicker,
  },
  watch: {},
  data() {
    return {
      param44444: "",
      period: [],
      url: "/users/updateDate",
      input: {},
      roles: [],
      functions: [],
      teams: [],
      language: "fr",
      languages: lang,
      settings: {
        maxScrollbarLength: 600,
        wheelSpeed: 0.6,
      },
      error: {},
    };
  },
  computed: {
    getApp() {
      return window.getApp;
    },
  },
  methods: {
    mountedFounction() {
      base_self.inputInitialize();
      base_self.getTeams();
      base_self.getFunctions();
      base_self.getRoles();
    },
    initInput() {
      base_self.input = JSON.parse(JSON.stringify(input_tempon));
    },
    inputInitialize() {
      base_self.base.item !== ""
        ? ((base_self.input = JSON.parse(JSON.stringify(base_self.base.item))),
          base_self.input.roles.length
            ? (base_self.input.role = base_self.input.roles[0])
            : (base_self.input.role = ""))
        : base_self.initInput();
      console.log("base_self.input: ", base_self.input);
    },
    getTeams() {
      base_self.$http.get("/teams").then((response) => {
        base_self.teams = response.data.data;
      });
    },
    getFunctions() {
      base_self.$http.get("/functions").then((response) => {
        base_self.functions = response.data.data;
      });
    },
    getRoles() {
      base_self.$http.get("/roles").then((response) => {
        base_self.roles = response.data.data;

        if (base_self.base.item === "") {
          for (var i = 0; i < base_self.roles.length; i++) {
            if (base_self.roles[i].id === 3) {
              base_self.input.role = JSON.parse(
                JSON.stringify(base_self.roles[i])
              );
              break;
            }
          }
        }
      });
    },
    submitData() {
      this.$vs.loading();
      this.$http
        .put(
          this.url + `/${base_self.$store.state.AppActiveUser.slug}`,
          this.input
        )
        .then((response) => {
          this.$vs.loading.close();
          if (response.data) {
            window.getApp.success("Les dates ont été modifiées avec succès.");
            Object.keys(this.input).forEach(
              (index) => (this.input[index] = null)
            );
            this.$router.push({ path: "/dashboard" });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status == 422) {
            this.$vs.notify({
              title: "Erreur",
              text: "Veuillez valider les champs du formulaire",
              color: "danger",
              position: "top-right",
            });
            this.$vs.loading.close();
            this.error = error.response.data.errors;
          }
        });
    },
    resetErrors(field) {
      if (field) {
        this.error[field] = null;
      } else {
        this.error = [];
        Object.keys(this.input).forEach((index) => (this.input[index] = null));
      }
    },
  },
  created() {
    base_self = this;
  },
  mounted() {
    for (let i = 1; i<101; i++){
        this.period.push(i)
    }
    //base_self.base.ajoutComponent = base_self;
    this.mountedFounction();
  },
};
</script>
